// These color tokens don't exist in StormUI
export const squidInk = '#232F3E'; // Global header background color
export const orange = '#FF6200'; // Sidenav active category color
